import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { CloseTemplateTypeFilter } from "@common/schemas/close-template.schema";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const options: FilterMultiselectOption[] = [
    { value: "general", label: "General", searchableLabel: "General" },
    {
        value: "client_specific",
        label: "Client specific",
        searchableLabel: "Client specific",
    },
];

export const TemplateTypeFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.closeTemplateType;
    const selected = value ? [value] : [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={selected}
                onChange={(vals) => {
                    if (vals.length === 0) {
                        onChange({ closeTemplateType: undefined });
                        return;
                    }
                    // Single-select: pick the newly added value.
                    const next = vals.find((v) => v !== value);
                    onChange({
                        closeTemplateType:
                            (next as CloseTemplateTypeFilter) ?? undefined,
                    });
                }}
                name="closeTemplateType"
                onBlur={noop}
            />
        </div>
    );
};
